/** Coins — Figma 4099:47531, outer 32×32, leaf inset 8.33% */
const CoinsIcon = ({ className }: { className?: string }) => (
    <span
        className={`relative inline-block size-8 shrink-0 overflow-hidden ${className ?? ""}`}
        aria-hidden
    >
        <span className="absolute inset-[8.33%]">
            <span className="absolute inset-[-1.88%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 27.6587 27.656"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.9533 11.66C23.2137 12.1299 24.3353 12.91 25.2143 13.9283C26.0933 14.9465 26.7014 16.1699 26.9823 17.4854C27.2632 18.8009 27.2079 20.166 26.8214 21.4545C26.4349 22.7429 25.7298 23.9131 24.7712 24.8568C23.8127 25.8005 22.6316 26.4873 21.3373 26.8536C20.043 27.22 18.6772 27.254 17.3662 26.9526C16.0553 26.6512 14.8415 26.0241 13.8371 25.1293C12.8327 24.2345 12.0702 23.1009 11.62 21.8333M7.16667 5.83333H8.5V11.1667M20.1133 16.34L21.0467 17.2867L17.2867 21.0467M16.5 8.5C16.5 12.9183 12.9183 16.5 8.5 16.5C4.08172 16.5 0.5 12.9183 0.5 8.5C0.5 4.08172 4.08172 0.5 8.5 0.5C12.9183 0.5 16.5 4.08172 16.5 8.5Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

export default CoinsIcon;
